export default __webpack_public_path__ + "static/media/vtex-hiring-coders.d00efd15.png";